import { reduce } from 'ramda'

import { parseAmount } from '../parseAmount'


export type DataItem = { sellPointID: string; value: string }

export function extractData(data: FormData) {
  const dataArray: Array<[string, string | File]> = Array.from(data)

  return reduce((acc, [itemID, itemValue]) => {
    if (itemID && itemValue) {
      const ID = itemID.replace(/\D/g, '')
      if (ID && typeof itemValue === 'string') {
        acc.push({ sellPointID: ID, value: String(parseAmount(itemValue)) })
      }
    }
    return acc
  }, [] as Array<DataItem>, dataArray)
}
